/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export enum RemarkType {
  TypeUnknown = "TypeUnknown",
  Regular = "Regular",
  RegularNegative = "RegularNegative",
  RegularInfo = "RegularInfo",
  Cashback = "Cashback",
  Warning = "Warning",
  WarningSoft = "WarningSoft",
  Cancellation = "Cancellation",
  TourOperatorVoucher = "TourOperatorVoucher",
  CancellationVoucher = "CancellationVoucher",
  Insurance = "Insurance",
  Rebookable = "Rebookable",
  Special = "Special",
  CancellationEconomic = "CancellationEconomic",
  CancellationCost = "CancellationCost",
  LowDeposit = "LowDeposit",
  CancellationOptIn = "CancellationOptIn",
  CancellationCostOptIn = "CancellationCostOptIn",
  Guarantee = "Guarantee",
  Flight = "Flight",
}

export function remarkTypeFromJSON(object: any): RemarkType {
  switch (object) {
    case 0:
    case "TypeUnknown":
      return RemarkType.TypeUnknown;
    case 1:
    case "Regular":
      return RemarkType.Regular;
    case 2:
    case "RegularNegative":
      return RemarkType.RegularNegative;
    case 3:
    case "RegularInfo":
      return RemarkType.RegularInfo;
    case 4:
    case "Cashback":
      return RemarkType.Cashback;
    case 5:
    case "Warning":
      return RemarkType.Warning;
    case 6:
    case "WarningSoft":
      return RemarkType.WarningSoft;
    case 7:
    case "Cancellation":
      return RemarkType.Cancellation;
    case 8:
    case "TourOperatorVoucher":
      return RemarkType.TourOperatorVoucher;
    case 9:
    case "CancellationVoucher":
      return RemarkType.CancellationVoucher;
    case 10:
    case "Insurance":
      return RemarkType.Insurance;
    case 11:
    case "Rebookable":
      return RemarkType.Rebookable;
    case 12:
    case "Special":
      return RemarkType.Special;
    case 13:
    case "CancellationEconomic":
      return RemarkType.CancellationEconomic;
    case 14:
    case "CancellationCost":
      return RemarkType.CancellationCost;
    case 15:
    case "LowDeposit":
      return RemarkType.LowDeposit;
    case 16:
    case "CancellationOptIn":
      return RemarkType.CancellationOptIn;
    case 17:
    case "CancellationCostOptIn":
      return RemarkType.CancellationCostOptIn;
    case 18:
    case "Guarantee":
      return RemarkType.Guarantee;
    case 19:
    case "Flight":
      return RemarkType.Flight;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum RemarkType"
      );
  }
}

export function remarkTypeToJSON(object: RemarkType): string {
  switch (object) {
    case RemarkType.TypeUnknown:
      return "TypeUnknown";
    case RemarkType.Regular:
      return "Regular";
    case RemarkType.RegularNegative:
      return "RegularNegative";
    case RemarkType.RegularInfo:
      return "RegularInfo";
    case RemarkType.Cashback:
      return "Cashback";
    case RemarkType.Warning:
      return "Warning";
    case RemarkType.WarningSoft:
      return "WarningSoft";
    case RemarkType.Cancellation:
      return "Cancellation";
    case RemarkType.TourOperatorVoucher:
      return "TourOperatorVoucher";
    case RemarkType.CancellationVoucher:
      return "CancellationVoucher";
    case RemarkType.Insurance:
      return "Insurance";
    case RemarkType.Rebookable:
      return "Rebookable";
    case RemarkType.Special:
      return "Special";
    case RemarkType.CancellationEconomic:
      return "CancellationEconomic";
    case RemarkType.CancellationCost:
      return "CancellationCost";
    case RemarkType.LowDeposit:
      return "LowDeposit";
    case RemarkType.CancellationOptIn:
      return "CancellationOptIn";
    case RemarkType.CancellationCostOptIn:
      return "CancellationCostOptIn";
    case RemarkType.Guarantee:
      return "Guarantee";
    case RemarkType.Flight:
      return "Flight";
    default:
      return "UNKNOWN";
  }
}

export function remarkTypeToNumber(object: RemarkType): number {
  switch (object) {
    case RemarkType.TypeUnknown:
      return 0;
    case RemarkType.Regular:
      return 1;
    case RemarkType.RegularNegative:
      return 2;
    case RemarkType.RegularInfo:
      return 3;
    case RemarkType.Cashback:
      return 4;
    case RemarkType.Warning:
      return 5;
    case RemarkType.WarningSoft:
      return 6;
    case RemarkType.Cancellation:
      return 7;
    case RemarkType.TourOperatorVoucher:
      return 8;
    case RemarkType.CancellationVoucher:
      return 9;
    case RemarkType.Insurance:
      return 10;
    case RemarkType.Rebookable:
      return 11;
    case RemarkType.Special:
      return 12;
    case RemarkType.CancellationEconomic:
      return 13;
    case RemarkType.CancellationCost:
      return 14;
    case RemarkType.LowDeposit:
      return 15;
    case RemarkType.CancellationOptIn:
      return 16;
    case RemarkType.CancellationCostOptIn:
      return 17;
    case RemarkType.Guarantee:
      return 18;
    case RemarkType.Flight:
      return 19;
    default:
      return 0;
  }
}

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
